import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Flex, Text, SimpleGrid, Select, Alert, AlertIcon, useToast } from '@chakra-ui/react';
import Pagination from '../../../shared/pagination/Pagination';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import TransactionsTable from './TransactionsTable';
import { getAllTransactions, updateTransactionStatus } from '../../../../store/wallet/walletSlice';
import { RulesWrapper } from '../rules/RulesStyle';
import theme from '../../../global/theme';

const STATUS_LABEL = { pending: 'قيد الانتظار', completed: 'مكتملة', failed: 'فشلت' };

const Transactions = () => {
  const dispatch = useDispatch();
  const toast = useToast({ position: 'top', duration: 3000 });
  const { adminTransactions } = useSelector(state => state.wallet);
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState('');

  const filter = JSON.stringify(status ? { status } : {});

  useEffect(() => { dispatch(getAllTransactions({ page, filter })); }, [dispatch, page, filter]);

  const handleUpdateStatus = (id, newStatus) => {
    dispatch(updateTransactionStatus({ id, status: newStatus }))
      .unwrap()
      .then(() => toast({ description: `تم تحديث حالة المعاملة إلى ${STATUS_LABEL[newStatus]}`, status: 'success' }));
  };

  return (
    <RulesWrapper>
      <Breadcrumbs currentPage="المعاملات المالية" pages={[{ name: 'لوحة التحكم', path: '/admin' }]} />
      {adminTransactions.errors.length > 0 && (
        <Alert status="error" variant="left-accent" marginBottom={8}>
          <AlertIcon />
          {adminTransactions.errors.map((e, i) => <Text key={i}>{e?.msg}</Text>)}
        </Alert>
      )}
      <SimpleGrid columns={{ sm: 1, md: 2 }} justifyContent="space-between">
        <Flex marginBottom={8} />
        <Flex marginBottom={8} justifyContent="flex-end">
          <Select
            width="auto" bg={theme.light} color={theme.dark} border="none"
            value={status} onChange={e => { setStatus(e.target.value); setPage(1); }}
          >
            <option value="">كل الحالات</option>
            <option value="pending">قيد الانتظار</option>
            <option value="completed">مكتملة</option>
            <option value="failed">فشلت</option>
          </Select>
        </Flex>
      </SimpleGrid>
      {adminTransactions.data?.itemsCount > 0 ? (
        <TransactionsTable data={adminTransactions.data.data} page={page} handleUpdateStatus={handleUpdateStatus} />
      ) : (
        <Flex textAlign="center" bg={theme.light} boxShadow={theme.shadow} height={200}
          alignItems="center" justifyContent="center" borderRadius={4}>
          <Text fontSize={18} color="gray.300" fontWeight="bold">لا توجد معاملات</Text>
        </Flex>
      )}
      <Flex justifyContent="flex-end">
        <Pagination page={page} itemsCount={adminTransactions.data?.itemsCount ?? 0} onChange={setPage} />
      </Flex>
    </RulesWrapper>
  );
};

export default Transactions;
